module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_try_on_dress_02-bed2019764e30fee93071a37aa058485.jpg";